export const QUIZZ_POST_REQUEST = "QUIZZ_POST_REQUEST";
export const QUIZZ_POST_SUCCESS = "QUIZZ_POST_SUCCESS";
export const QUIZZ_POST_FAIL = "QUIZZ_POST_FAIL";

export const QUIZZ_LIST_REQUEST = "QUIZZ_LIST_REQUEST";
export const QUIZZ_LIST_SUCCESS = "QUIZZ_LIST_SUCCESS";
export const QUIZZ_LIST_FAIL = "QUIZZ_LIST_FAIL";
